import { render, staticRenderFns } from "./PlaylistLibrary.vue?vue&type=template&id=5fc8e481"
import script from "./PlaylistLibrary.vue?vue&type=script&lang=ts"
export * from "./PlaylistLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports